export default {
  'AdminUser': {
    collection: 'adminUsers',
    element: 'adminUser',
    label: 'name',
    enum: {
    },
    associations: {
      roles: {
        foreign_key: 'admin_user_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'admin_user_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      operation_records: {
        foreign_key: 'operator_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      operatable_records: {
        foreign_key: 'operatable_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
    }
  },
  'AdminUsersRole': {
    collection: 'adminUsersRoles',
    element: 'adminUsersRole',
    label: 'id',
    enum: {
    },
    associations: {
      admin_user: {
        foreign_key: 'admin_user_id',
        primary_key: 'id',
        class_name: 'AdminUser',
        polymorphic: false
      },
      role: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
    }
  },
  'Role': {
    collection: 'roles',
    element: 'role',
    label: 'name',
    enum: {
      kinds: [
        'super',
        'application',
        'custom',
      ],
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        class_name: 'Creator',
        polymorphic: true
      },
      operatable_records: {
        foreign_key: 'operatable_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
    }
  },
  'Application': {
    collection: 'applications',
    element: 'application',
    label: 'name',
    enum: {
    },
    associations: {
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'AdminUser',
        polymorphic: false
      },
      wechat_application: {
        foreign_key: 'wechat_application_id',
        primary_key: 'id',
        class_name: 'BsWechatMiniProgram::Application',
        polymorphic: false
      },
      pages: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Page',
        polymorphic: false
      },
      operation_records: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      roles: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      application_admin_users_role: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      custom_pages: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
      users: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      poster_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      poster_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      share_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      share_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      logo_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      logo_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      banner_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      banner_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      mine_banner_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      mine_banner_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      home_popup_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      home_popup_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      standard_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      standard_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      standard_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      standard_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      business_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      business_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      nov_standard_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      nov_standard_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      nov_standard_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      nov_standard_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      nov_business_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      nov_business_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'ActiveStorage::Attachment': {
    collection: 'activeStorage/attachments',
    element: 'activeStorage/attachment',
    label: 'name',
    enum: {
    },
    associations: {
      record: {
        foreign_key: 'record_id',
        class_name: 'Record',
        polymorphic: true
      },
      blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'LocalScenery': {
    collection: 'localSceneries',
    element: 'localScenery',
    label: 'name',
    enum: {
      jump_page_types: [
        'local',
        'mini_program',
      ],
      env_versions: [
        'release',
        'develop',
        'trial',
      ],
    },
    associations: {
      cover_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      cover_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      local_scenery_stations: {
        foreign_key: 'local_scenery_id',
        primary_key: 'id',
        class_name: 'LocalSceneryStation',
        polymorphic: false
      },
      stations: {
        foreign_key: 'station_id',
        primary_key: 'id',
        class_name: 'Station',
        polymorphic: false
      },
    }
  },
  'Station': {
    collection: 'stations',
    element: 'station',
    label: 'id',
    enum: {
    },
    associations: {
      standard_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      standard_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      standard_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      standard_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      business_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      business_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      nov_standard_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      nov_standard_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      nov_standard_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      nov_standard_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      nov_business_premier_services_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      nov_business_premier_services_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      local_scenery_stations: {
        foreign_key: 'station_id',
        primary_key: 'id',
        class_name: 'LocalSceneryStation',
        polymorphic: false
      },
      local_sceneries: {
        foreign_key: 'local_scenery_id',
        primary_key: 'id',
        class_name: 'LocalScenery',
        polymorphic: false
      },
      origin_routes: {
        foreign_key: 'origin_id',
        primary_key: 'id',
        class_name: 'Route',
        polymorphic: false
      },
      destination_routes: {
        foreign_key: 'destination_id',
        primary_key: 'id',
        class_name: 'Route',
        polymorphic: false
      },
    }
  },
  'User': {
    collection: 'users',
    element: 'user',
    label: 'email',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      avatar_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      avatar_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      user_oauth_identity_accounts: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'UserOauthIdentityAccount',
        polymorphic: false
      },
      profile: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Profile',
        polymorphic: false
      },
      oauth_identity_accounts: {
        foreign_key: 'oauth_identity_account_id',
        primary_key: 'id',
        class_name: 'OauthIdentityAccount',
        polymorphic: false
      },
      passengers: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Passenger',
        polymorphic: false
      },
      bookings: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Booking',
        polymorphic: false
      },
    }
  },
  'Profile': {
    collection: 'profiles',
    element: 'profile',
    label: 'name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'ActiveStorage::Blob': {
    collection: 'activeStorage/blobs',
    element: 'activeStorage/blob',
    label: 'id',
    enum: {
    },
    associations: {
      variant_records: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::VariantRecord',
        polymorphic: false
      },
      preview_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      preview_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      attachments: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'Attachment',
        polymorphic: false
      },
      taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      base_tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      tag_taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      uploader: {
        foreign_key: 'uploader_id',
        class_name: 'Uploader',
        polymorphic: true
      },
    }
  },
  'ActsAsTaggableOn::Tag': {
    collection: 'actsAsTaggableOn/tags',
    element: 'actsAsTaggableOn/tag',
    label: 'name',
    enum: {
    },
    associations: {
      taggings: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
    }
  },
  'Page': {
    collection: 'pages',
    element: 'page',
    label: 'title',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      wxacode_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      wxacode_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'CustomPage': {
    collection: 'customPages',
    element: 'customPage',
    label: 'title',
    enum: {
    },
    associations: {
      formal_custom_page: {
        foreign_key: 'draft_custom_page_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
      draft_custom_page: {
        foreign_key: 'draft_custom_page_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
    }
  },
  'OperationRecord': {
    collection: 'operationRecords',
    element: 'operationRecord',
    label: 'id',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      operator: {
        foreign_key: 'operator_id',
        class_name: 'Operator',
        polymorphic: true
      },
      operatable: {
        foreign_key: 'operatable_id',
        class_name: 'Operatable',
        polymorphic: true
      },
    }
  },
  'FrequentlyAskedQuestion': {
    collection: 'frequentlyAskedQuestions',
    element: 'frequentlyAskedQuestion',
    label: 'id',
    enum: {
    },
    associations: {
    }
  },
  'Passenger': {
    collection: 'passengers',
    element: 'passenger',
    label: 'email',
    enum: {
      passenger_types: [
        'adult',
        'senior',
        'youth',
        'child',
      ],
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'Booking': {
    collection: 'bookings',
    element: 'booking',
    label: 'id',
    enum: {
      statuses: [
        'provisional',
        'wait_to_pay',
        'wait_to_add_payment',
        'ready_to_be_confirmed',
        'confirmed',
        'in_aftersales',
        'cancelled',
        'rebooking',
        'closed',
      ],
      refund_states: [
        'pending',
        'partial_refund',
        'all_refund',
      ],
    },
    associations: {
      payments: {
        foreign_key: 'booking_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
      charge_payments: {
        foreign_key: 'booking_id',
        primary_key: 'id',
        class_name: 'ChargePayment',
        polymorphic: false
      },
      refund_payments: {
        foreign_key: 'booking_id',
        primary_key: 'id',
        class_name: 'RefundPayment',
        polymorphic: false
      },
      paid_payments: {
        foreign_key: 'booking_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'Payment': {
    collection: 'payments',
    element: 'payment',
    label: 'id',
    enum: {
      statuses: [
        'pending',
        'not_processed',
        'expired',
        'call_failed',
        'authorized',
        'not_authorized',
      ],
    },
    associations: {
      booking: {
        foreign_key: 'booking_id',
        primary_key: 'id',
        class_name: 'Booking',
        polymorphic: false
      },
    }
  },
  'Route': {
    collection: 'routes',
    element: 'route',
    label: 'id',
    enum: {
    },
    associations: {
      origin: {
        foreign_key: 'origin_id',
        primary_key: 'id',
        class_name: 'Station',
        polymorphic: false
      },
      destination: {
        foreign_key: 'destination_id',
        primary_key: 'id',
        class_name: 'Station',
        polymorphic: false
      },
    }
  },
  'RequestLog': {
    collection: 'requestLogs',
    element: 'requestLog',
    label: 'title',
    enum: {
    },
    associations: {
    }
  },
}
